<template>
  <div class="Adopt">

    <slider :items="items" v-if="animal.id" />

  </div>
</template>

<script>
import Slider from 'components/Slider/Slider'

export default {
  name: 'Adopt',

  components: {
    Slider
  },

  watch: {
    '$route.query.page' () {
      this.$analytics.event(`Adopt/Page${this.$route.query.page}`)
    }
  },

  mounted () {
    // Wait a little for the analytics start event to dispatch
    setTimeout(() => {
      this.$analytics.event(`Adopt/Page1`)
    }, 100)
  },

  computed: {
    animal () { return this.$store.state.animal },

    /**
     * TODO: this content should really come from the API
     */
    items () {
      const image = 'static/images/adoption_guide_image.jpg'
      const template = 'text'

      return [
        {
          image,
          template,
          content: {
            title: 'Interested in Adopting?',
            subtitle: 'Begin by filling out our <br> Adoption Questionnaire',
            text: '<div class="Adopt-qr-codes">' +
                '<div class="Adopt-qr-box">' +
                  '<h4>Dogs</h4>' +
                  '<img src="static/images/qr-code-dog-questionnaire.png">' +
                '</div>' +
                '<div class="Adopt-qr-box">' +
                  '<h4>Cats</h4>' +
                  '<img src="static/images/qr-code-cat-questionnaire.png">' +
                '</div>' +
              '</div>'
          }
        }
      ]
    }
  }
}
</script>

<style>
  .Adopt-qr-codes {
    display: flex;
    justify-content: space-evenly;
  }
  .Adopt-qr-codes img {
    width: 150px;
  }
  .Adopt-qr-codes .Adopt-qr-box h4 {
    margin-bottom: 0.5em;
  }
</style>



// WEBPACK FOOTER //
// Adopt.vue?8f6e4d70